import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 岗位管理数据
    PostManagement({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Duty/GetGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存岗位管理数据
    savePostManagement({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/Duty/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除设备属性
    DeletePostManagement({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/Duty/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取单位列表数据
    GetAttributetype({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsData/GetSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
